<div class="container" style="margin-bottom:30px">
  <div class="row">
    <div class="col-xs-12 align-center">
      <div class="companyicon">
        <img ng-hide="branding.hideCompanyLogo" [src]="branding.logo_file_url"/>
      </div>
    </div>
  </div>
</div>

<div class="container-1024" *ngIf="step === '2fa'" >
    <app-set-up (twoFaLogOut)="step='login'" [isEmbedded]="true"></app-set-up>
</div>

<div class="container-1024" style="margin-top:-20px" *ngIf="step === 'login'" >
  <div class="row" align="center" style="margin-bottom: 10px">
    <div style="
        height: 1px;
        margin-bottom: 30px;
  overflow: visible;
  border: none;
  background: none;
  background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(150, 150, 150, 0)), color-stop(15%, rgba(150, 150, 150, 0)), color-stop(50%, rgba(150, 150, 150, 0.65)), color-stop(85%, rgba(150, 150, 150, 0)), color-stop(100%, rgba(150, 150, 150, 0)));
  background: -webkit-linear-gradient(left, rgba(150, 150, 150, 0) 0%, rgba(150, 150, 150, 0) 15%, rgba(150, 150, 150, 0.65) 50%, rgba(150, 150, 150, 0) 85%, rgba(150, 150, 150, 0) 100%);
  background: -moz-linear-gradient(left, rgba(150, 150, 150, 0) 0%, rgba(150, 150, 150, 0) 15%, rgba(150, 150, 150, 0.65) 50%, rgba(150, 150, 150, 0) 85%, rgba(150, 150, 150, 0) 100%);
  background: -ms-linear-gradient(left, rgba(150, 150, 150, 0) 0%, rgba(150, 150, 150, 0) 15%, rgba(150, 150, 150, 0.65) 50%, rgba(150, 150, 150, 0) 85%, rgba(150, 150, 150, 0) 100%);
  background: -o-linear-gradient(left, rgba(150, 150, 150, 0) 0%, rgba(150, 150, 150, 0) 15%, rgba(150, 150, 150, 0.65) 50%, rgba(150, 150, 150, 0) 85%, rgba(150, 150, 150, 0) 100%);
  background: linear-gradient(left, rgba(150, 150, 150, 0) 0%, rgba(150, 150, 150, 0) 15%, rgba(150, 150, 150, 0.65) 50%, rgba(150, 150, 150, 0) 85%, rgba(150, 150, 150, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#00000000', GradientType=1);"></div>
    <div
      *ngIf="branding.welcome_message != '' && branding.welcome_message != null && branding.welcome_message !== undefined"
      [innerHTML]="branding.welcome_message" style="margin-bottom: 30px"></div>
  </div>

  <div class="row show-mobile" style="padding: 0 15px">
    <span class="pull-right" style="margin-bottom: 2em;">
      <div class="dropdown">
          <button class="btn btn-primary dropdown-toggle" type="button"
                  data-toggle="dropdown">{{ localeButtonString }}
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
             <li><a href="javascript:void(0)" (click)="setLocalization('en')">En</a></li>
          <li><a href="javascript:void(0)" (click)="setLocalization('fr')">Fr</a></li>
          </ul>
      </div>
    </span>
  </div>

  <div class="row" style="padding: 0 15px">

    <mat-card class="col-sm-7 col-xs-12 form-mat-card">
      <h1> {{localeButtonString === 'fr' ? 'Se Connecter' : 'Sign In'}} </h1>

      <div class="row">
        <div class="form-item">
          <p class="bg-danger" id="error-messages-container" *ngFor="let error of errors | keyvalue">
            {{ error.value[0] }}
          </p>
        </div>
      </div>

      <div class="row">
        <form (submit)="login()" class="form-horizontal" role="form" id="signin-form">
          <!-- David doesn't like labels -->
          <!-- <label>{{'Email' | translate}}</label> --> 
          <mat-form-field class="full-width-field">
              <input 
                matInput 
                [(ngModel)]="authData.email"
                autocomplete="on"
                id="email-input"
                name="email"
                type="email"
                placeholder="{{localeButtonString === 'fr' ? 'Adresse De Courriel' : 'Enter Email'}}"
          ></mat-form-field>
          <!-- David doesn't like labels -->
          <!-- <label>{{'Password' | translate}}</label> -->
          <mat-form-field class="full-width-field">
              <input
                  matInput
                  [(ngModel)]="authData.password"
                  [type]="(showPassword | async) ? 'text' : 'password'"
                  name="password"
                  [placeholder]="localeButtonString === 'fr' ? 'Mot De Passe' : 'Password'"
              />
              <button matSuffix mat-icon-button type="button" tabindex="-1" (click)="toggleShowPassword()">
                  <mat-icon svgIcon="pq:eye"></mat-icon>
              </button>
          </mat-form-field>
          <div class="row" style="  margin-bottom: 10px;">
            <div class="col-xs-8 col-xs-offset-2" style="text-align: center">
              <button type="submit" *ngIf="!loggingIn" class="btn btn-primary">{{localeButtonString == 'fr' ? 'ACCÈS' : 'LOGIN'}}</button>
             <div>
               <a *ngIf="branding.azure_sso_enabled" style="margin-top: 15px"  href="/login/azure?company={{branding.company_id}}">
                 <svg  style="margin-top: 15px"   xmlns="http://www.w3.org/2000/svg" width="104" height="41" viewBox="0 0 104 41"><title>MS-SymbolLockup</title><rect width="104" height="41" fill="#2f2f2f"/><rect x="13" y="11" width="9" height="9" fill="#f25022"/><rect x="13" y="21" width="9" height="9" fill="#00a4ef"/><rect x="23" y="11" width="9" height="9" fill="#7fba00"/><rect x="23" y="21" width="9" height="9" fill="#ffb900"/><path d="M45.812,25.082V23.288a2.77,2.77,0,0,0,.573.4,4.484,4.484,0,0,0,.706.3,5.486,5.486,0,0,0,.745.187,3.954,3.954,0,0,0,.687.065,2.928,2.928,0,0,0,1.634-.365,1.2,1.2,0,0,0,.537-1.062,1.167,1.167,0,0,0-.178-.649,1.939,1.939,0,0,0-.5-.5,5.412,5.412,0,0,0-.757-.435q-.435-.209-.932-.436-.533-.285-.994-.578a4.285,4.285,0,0,1-.8-.648,2.724,2.724,0,0,1-.533-.8,2.6,2.6,0,0,1-.194-1.047,2.416,2.416,0,0,1,.333-1.285,2.794,2.794,0,0,1,.877-.9,4.019,4.019,0,0,1,1.239-.528,5.906,5.906,0,0,1,1.418-.172,5.692,5.692,0,0,1,2.4.374v1.721a3.817,3.817,0,0,0-2.295-.645,4.093,4.093,0,0,0-.771.074,2.335,2.335,0,0,0-.687.241,1.5,1.5,0,0,0-.494.433,1.06,1.06,0,0,0-.189.637,1.221,1.221,0,0,0,.145.608,1.573,1.573,0,0,0,.428.468,4.321,4.321,0,0,0,.688.414c.27.134.584.28.939.436q.548.285,1.034.6a4.881,4.881,0,0,1,.856.7,3.075,3.075,0,0,1,.585.846,2.493,2.493,0,0,1,.215,1.058,2.625,2.625,0,0,1-.322,1.348,2.584,2.584,0,0,1-.866.892,3.786,3.786,0,0,1-1.254.5,6.959,6.959,0,0,1-1.5.155c-.176,0-.392-.014-.647-.04s-.518-.067-.786-.117a7.75,7.75,0,0,1-.76-.187A2.373,2.373,0,0,1,45.812,25.082Z" fill="#fff"/><path d="M55.109,16.426a1.021,1.021,0,0,1-.713-.272.891.891,0,0,1-.3-.688.917.917,0,0,1,.3-.7,1.009,1.009,0,0,1,.713-.278,1.041,1.041,0,0,1,.732.278.915.915,0,0,1,.3.7.9.9,0,0,1-.3.678A1.035,1.035,0,0,1,55.109,16.426ZM55.95,25.5h-1.7V18h1.7Z" fill="#fff"/><path d="M64.979,24.9q0,4.131-4.146,4.131a6.166,6.166,0,0,1-2.551-.491V26.986a4.712,4.712,0,0,0,2.332.7,2.341,2.341,0,0,0,2.668-2.628V24.24h-.029a2.938,2.938,0,0,1-4.733.436,4.046,4.046,0,0,1-.837-2.684,4.738,4.738,0,0,1,.9-3.04,2.988,2.988,0,0,1,2.471-1.128,2.38,2.38,0,0,1,2.2,1.216h.029V18h1.7ZM63.3,22.064v-.973a1.91,1.91,0,0,0-.523-1.352,1.71,1.71,0,0,0-1.3-.559,1.789,1.789,0,0,0-1.51.714,3.223,3.223,0,0,0-.545,2,2.78,2.78,0,0,0,.523,1.769,1.675,1.675,0,0,0,1.385.662,1.8,1.8,0,0,0,1.426-.632A2.4,2.4,0,0,0,63.3,22.064Z" fill="#fff"/><path d="M73.853,25.5h-1.7V21.273q0-2.1-1.483-2.1a1.616,1.616,0,0,0-1.279.582,2.167,2.167,0,0,0-.505,1.469V25.5h-1.7V18h1.7v1.245h.029a2.669,2.669,0,0,1,2.428-1.421,2.257,2.257,0,0,1,1.863.795,3.57,3.57,0,0,1,.644,2.3Z" fill="#fff"/><path d="M80.892,16.426a1.017,1.017,0,0,1-.713-.272.889.889,0,0,1-.3-.688.915.915,0,0,1,.3-.7,1,1,0,0,1,.713-.278,1.038,1.038,0,0,1,.731.278.915.915,0,0,1,.3.7.9.9,0,0,1-.3.678A1.033,1.033,0,0,1,80.892,16.426Zm.84,9.074h-1.7V18h1.7Z" fill="#fff"/><path d="M90.614,25.5h-1.7V21.273q0-2.1-1.483-2.1a1.62,1.62,0,0,0-1.28.582,2.167,2.167,0,0,0-.5,1.469V25.5h-1.7V18h1.7v1.245h.03a2.668,2.668,0,0,1,2.427-1.421,2.258,2.258,0,0,1,1.864.795,3.576,3.576,0,0,1,.643,2.3Z" fill="#fff"/></svg>
               </a>
             </div>
              <img src="/assets/images/loading.gif" width="25%" *ngIf="loggingIn" />
            </div>
          </div>
        </form>

        <div class="one-row one-row-space-around">
          <mat-checkbox [(ngModel)]="authData.remember_me" color="primary" id="remember-me-checkbox">{{localeButtonString == 'fr' ? 'Mémoriser mon courriel' : 'Remember my email'}}</mat-checkbox>
          <a href="javascript:void(0)" (click)="goForgotPassword()">
            <label style="cursor: pointer;">{{localeButtonString == 'fr' ? 'Mot de passe oublié?' : 'Forgot password?'}}</label>
          </a>
        </div>

      </div>

    </mat-card>

    <div class="col-xs-12 col-sm-5" *ngIf="!isApp">
            <span class="pull-right hide-mobile" ng-if="1">
                <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button"
                            data-toggle="dropdown">{{ localeButtonString }}
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                        <li><a href="javascript:void(0)" (click)="setLocalization('en')">En</a></li>
                        <li><a href="javascript:void(0)" (click)="setLocalization('fr')">Fr</a></li>
                    </ul>
                </div>
            </span>

      <h1>{{localeButtonString == 'fr' ? 'S\'enregistrer' : 'Sign Up'}}</h1>
      <div
        ng-if="branding.login_register_message != '' && branding.login_register_message != null && branding.login_register_message !== undefined"
        compile="branding.login_register_message" ng-click="openLink($event)"></div>
      <div ng-if="branding.login_register_message == '' || branding.login_register_message == null || branding.login_register_message === undefined">
        <p style="margin-top:20px;">{{localeButtonString == 'fr' ? 'Vous n\'êtes pas membre Payquad? Inscrivez-vous et accédez à ces excellents services!' : 'Not a PayQuad Member? Register to gain access to these great services!'}}</p>
        <div class="row">
          <ul>
            <li>{{localeButtonString == 'fr' ? 'Mise à jour des nouvelles communautaires' : 'Community news updates'}}</li>
            <li>{{localeButtonString == 'fr' ? 'Montants prévus' : 'Scheduled payments'}}</li>
            <li>{{localeButtonString == 'fr' ? 'Historique de paiements' : 'Payment history'}}</li>
          </ul>
        </div>
      </div>
      <div class="row" style="margin-top:5px; margin-bottom: 10px;">
        <div class="col-xs-12 col-sm-6 col-sm-offset-2">
          <a href="javascript:void(0)" (click)="goRegister()">
            <button type="button"
                    id="register-btn"
                    class="btn btn-default">
              {{localeButtonString == 'fr' ? 'S\'inscrire' : 'REGISTER'}}
            </button>
          </a>
        </div>
      </div>
      <div class="row" style="margin-top:5px; margin-bottom: 10px;" ng-if="platform === 'web'">
        <div class="col-xs-6 col-sm-6">
          <div class="form-item forgot-passtext-right-sm">
            <a href="{{branding.android_application_link}}">
              <img src="/assets/images/google-play-badge.png" style="max-width: 210px;width: 100%;margin-top:2px">
            </a>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6">
          <div class="form-item forgot-passtext-right-sm">
            <a href="{{branding.ios_application_link}}">
              <img src="/assets/images/download-on-the-app-store.png"
                   style="max-width: 210px;width: 100%;margin-left:10px;">
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<div class="modal fade"
     id="update-mobile-app-modal"
     tabindex="-1"
     role="dialog"
     data-keyboard="false" data-backdrop="static"
     aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" style="text-align: center">
        <h2>{{'The App Needs to be Updated' | translate}}</h2>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12 text-center">
            <h3 ng-if="platform === 'ios'">Please download the newest version from the App Store"</h3>
            <h3 ng-if="platform === 'android'"> Please download the newest version from the Google Play/</h3>
          </div>
        </div>
        <div class="row">
          <div ng-if="platform === 'ios' && pqAppId === 'com.payquad'">
            <div class="form-item text-center">
              <a href="https://apps.apple.com/ca/app/my-portal-by-payquad/id1502174216">
                <img src="/assets/images/download-on-the-app-store.png" style="height:86px; margin-left:10px;">
              </a>
            </div>
          </div>

          <div ng-if="platform === 'ios' && pqAppId === 'com.payquad.manager'">
            <div class="form-item text-center">
              <a href="https://apps.apple.com/ca/app/manager-app-by-payquad/id1551011738">
                <img src="/assets/images/download-on-the-app-store.png" style="height:86px; margin-left:10px;">
              </a>
            </div>
          </div>


          <div ng-if="platform === 'ios' && pqAppId === 'com.medallion.app'">
            <div class="form-item text-center">
              <a href="https://apps.apple.com/ca/app/my-medallion/id1555362357">
                <img src="/assets/images/download-on-the-app-store.png" style="height:86px; margin-left:10px;">
              </a>
            </div>
          </div>

          <div ng-if="platform === 'android' && pqAppId === 'com.payquad'">
            <div class="form-item text-center">
              <a ng-click="openStoreLink(platform, pqAppId)">
                <img src="/assets/images/google-play-badge.png" style="width:210px; margin-top:2px">
              </a>
            </div>
          </div>

          <div ng-if="platform === 'android' && pqAppId === 'com.payquad.manager'">
            <div class="form-item text-center">
              <a ng-click="openStoreLink(platform, pqAppId)">
                <img src="/assets/images/google-play-badge.png" style="width:210px; margin-top:2px">
              </a>
            </div>
          </div>

          <div ng-if="platform === 'android' && pqAppId === 'com.payquad'">
            <div class="form-item text-center">
              <a ng-click="openStoreLink(platform, pqAppId)">
                <img src="/assets/images/google-play-badge.png" style="width:210px; margin-top:2px">
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
